import axios from '../http'; // 导入http中创建的axios实例
import qs from 'qs'; // 根据需求是否导入qs模块,post数据需要qs格式化
import base from './base'// 导入接口域名列表

//系统管理相关接口
const myAllWork={

//登录 卡号密码
  getPage(params){
    return axios.post(`${base.bs}/guest/examKs/page`,params);
  },
//创建试卷
  getPaper(params){
    return axios.get(`${base.bs}/guest/examKs/getPaper/${params.cardid}`,null);
  },
  //创建试卷
  createSj(params){
    return axios.get(`${base.bs}/guest/examKs/createSj/${params.isjx}/${params.cardid}`,null);
  },

//获取考试试卷
  getExamAllInfo(params){
    return axios.get(`${base.bs}/guest/examKs/getExamAllInfo/${params.examid}`,null);
  },
//保存答案
  saveAnswer(params){
    return axios.get(`${base.bs}/guest/examKs/saveAnswer/${params.examid}/${params.qid}`,{params:{answer:params.answer}});
  },
//保存剩余时间
  saveSytime(params){
    return axios.get(`${base.bs}/guest/examKs/saveSytime/${params.examid}/${params.sytime}`,null);
  },
//交卷
  jj(params){
    return axios.get(`${base.bs}/guest/examKs/jj/${params.examid}`,null);
  },
//读取错题
  getCtList(params){
    return axios.get(`${base.bs}/guest/examKs/getCtList/${params.cardid}`,null);
  },
//删除一个错题
  delCt(params){
    return axios.get(`${base.bs}/guest/examKs/delCt/${params.id}`,null);
  },
//删除所有错题
  delAllCt(params){
    return axios.get(`${base.bs}/guest/examKs/delAllCt/${params.cardid}`,null);
  },
}
// 导出接口
export  default myAllWork;



// WEBPACK FOOTER //
// ./src/request/api/myExam.js